import { registerLocaleData } from '@angular/common';
import localeGerman from '@angular/common/locales/de';
import localeSpanish from '@angular/common/locales/es';
import localeFrench from '@angular/common/locales/fr';
import localeDutch from '@angular/common/locales/nl';
import localePortuguese from '@angular/common/locales/pt';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SupportedLanguages } from '@skyfit/core-data-library';

@Injectable({
  providedIn: 'root',
})
export class TranslatorService {
  private readonly translateService = inject(TranslateService);

  private getLanguageFromBrowserLocale(): SupportedLanguages {
    const locale =
      window.navigator.language || window.navigator['userLanguage'];
    let languageMatch = SupportedLanguages.english;

    if (locale) {
      const localeSplit = locale.split('-');
      const language = localeSplit?.length ? localeSplit[0] : '';
      const key = Object.keys(SupportedLanguages).find(
        (languageKey) => SupportedLanguages[languageKey] === language
      );
      if (key) {
        languageMatch = SupportedLanguages[key];
      }
    }

    return languageMatch;
  }

  private registerLocalLanguageData(language: SupportedLanguages) {
    switch (language) {
      case SupportedLanguages.dutch:
        registerLocaleData(localeDutch, SupportedLanguages.dutch);
        break;
      case SupportedLanguages.french:
        registerLocaleData(localeFrench, SupportedLanguages.french);
        break;
      case SupportedLanguages.portuguese:
        registerLocaleData(localePortuguese, SupportedLanguages.portuguese);
        break;
      case SupportedLanguages.spanish:
        registerLocaleData(localeSpanish, SupportedLanguages.spanish);
        break;
      case SupportedLanguages.german:
        registerLocaleData(localeGerman, SupportedLanguages.german);
    }
  }

  translate(key: string, interpolateParams?: any): string {
    return this.translateService.instant(key, interpolateParams);
  }

  initTranslateService(): void {
    this.translateService.setDefaultLang(SupportedLanguages.english);
    this.translateService.addLangs(
      Object.keys(SupportedLanguages).filter((key) => SupportedLanguages[key])
    );
    const localLanguage = this.getLanguageFromBrowserLocale();
    this.translateService.use(localLanguage);
    this.registerLocalLanguageData(localLanguage);
  }
}
